import { create } from 'zustand';

// Initial state object to use for both initial values and reset
const initialState = {
  prescriptions: [],
  selectedMedication: null,
  selectedDiagnosis: {
    code: "",
    description: "",
    id: null,
    title: ""
  },
  selectedQuantity: { id: "1", name: "1 συσκευασία" },
  selectedDose: { id: 1, name: "1 δισκίο" },
  selectedFrequency: { id: 1, name: "1 φορά την ημέρα" },
  selectedDays: { id: 30, name: "30 ημέρες" },
  selectedRepeat: { id: 1, name: "ΑΠΛΗ" },
  selectedInterval: { id: null, intervalDescription: "" },
  selectedCopayment: { id: 3, name: "25 %" },
  medicationComment: "",
  prescriptionComment: "",
  newVisit:null
};

const useStore = create((set) => ({
  // Initialize with initial state
  ...initialState,

  // Prescriptions actions
  addPrescription: (prescription) => 
    set((state) => ({ 
      prescriptions: prescription
    })),

  removeMedicine: (prescriptionId, medicineIndex) => set((state) => {
    const prescriptions = state.prescriptions.map(prescription => {
      if (prescription.id === prescriptionId) {
        // Remove medicine at specified index
        const medicines = prescription.medicines.filter((_, idx) => idx !== medicineIndex);
        return { ...prescription, medicines };
      }
      return prescription;
    }).filter(prescription => prescription.medicines.length > 0); // Remove empty prescriptions

    return { prescriptions };
  }),
  
  // Form state setters
  setNewVisit: (visit) => 
    set({ newVisit: visit }),

  setSelectedMedication: (medication) => 
    set({ selectedMedication: medication }),
  
  setSelectedDiagnosis: (diagnosis) => 
    set({ selectedDiagnosis: diagnosis }),
  
  setSelectedQuantity: (quantity) => 
    set({ selectedQuantity: quantity }),
  
  setSelectedDose: (dose) => 
    set({ selectedDose: dose }),
  
  setSelectedFrequency: (frequency) => 
    set({ selectedFrequency: frequency }),
  
  setSelectedDays: (days) => 
    set({ selectedDays: days }),
  
  setSelectedRepeat: (repeat) => 
    set({ selectedRepeat: repeat }),

  setSelectedInterval: (interval) => 
    set({ selectedInterval: interval }),
  
  setSelectedCopayment: (copayment) => 
    set({ selectedCopayment: copayment }),
  
  setMedicationComment: (comment) => 
    set({ medicationComment: comment }),
  
  setPrescriptionComment: (comment) => 
    set({ prescriptionComment: comment }),
  
  // Partial reset (original)
  resetForm: () => set({
    selectedMedication: null,
    selectedDiagnosis: {
      code: "",
      description: "",
      id: null,
      title: ""
    },
    medicationComment: "",
    prescriptionComment: ""
  }),

  resetMedicineData: () => set({
    selectedMedication: initialState.selectedMedication,
    selectedDiagnosis: initialState.selectedDiagnosis,
    selectedQuantity: initialState.selectedQuantity,
    selectedDose: initialState.selectedDose,
    selectedFrequency: initialState.selectedFrequency,
    selectedDays: initialState.selectedDays, 
    selectedRepeat: initialState.selectedRepeat,
    selectedInterval: initialState.selectedInterval,
    selectedCopayment: initialState.selectedCopayment,
    medicationComment: initialState.medicationComment
  }),

  // Complete reset - resets everything to initial state
  resetAll: () => set(initialState)
}));

export default useStore;